import { SubjectModelListItem } from '../_objects/subject-model';

export class SubjectModelWrapper {
  public subjectModel: SubjectModelListItem;
  public order: number;
  constructor(subjectModel: SubjectModelListItem) {
    this.subjectModel = subjectModel;
  }
}
